<template>
  <div class="main-container">
    <iframe id="mainIframe"
            name="mainIframe"
            :src="pageSrc"
            frameborder="0"
            scrolling="auto"></iframe>
  </div>
</template>

<script>
import CookieOperation from '@/plugins/cookie'

export default {
  name: 'PageRuntime',
  data () {
    return {
      dataId: this.$route.params.id,
      token: this.$route.query.token
    }
  },
  computed: {
    pageSrc () {
      return `/page-app/iframe-runtime/${this.dataId}?token=${this.token}&tenantId=${CookieOperation.getTenantId()}`
    }
  }
}
</script>

<style scoped lang="scss">
.main-container {
  height: 100%;
  width: 100%;

  #mainIframe {
    height: 100%;
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/page/runtime/page-runtime.vue